import {useRef, useEffect, useState} from 'react';

export interface TShow {
    isOpen: boolean;
    showClass: string;
    open: () => void;
    close: (e?: Event | React.SyntheticEvent) => Promise<void>;
}

export default function useShow(duration: number = 300): TShow {
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [showClass, setShowClass] = useState<string>('');

    const timeout = useRef<ReturnType<typeof setTimeout> | null>(null);

    const close = (e?: Event | React.SyntheticEvent): Promise<void> => new Promise((resolve) => {
        if(!isOpen)
            return;
        if(e)
            e.stopPropagation();
        setShowClass('');
        if(timeout.current) clearTimeout(timeout.current);
        timeout.current = setTimeout(() => {
            setIsOpen(false);
            resolve();
        }, duration);
    });

    const open = () => {
        setIsOpen(true);
        if(timeout.current) clearTimeout(timeout.current);
        timeout.current = setImmediate(() => {
            setShowClass(' show');
        }) as unknown as ReturnType<typeof setTimeout>;
    };

    useEffect(() => () => {
        if(timeout.current) clearTimeout(timeout.current);
    }, []);

    return {open, close, isOpen, showClass};
}
